import { proxy } from "valtio";
import { getSupportUnread } from "../apis/feedback/get.support.unread";

// Support is surfaced through a drawer (chat + FAQ) launched from the support
// icon, with its own unread count — it intentionally does NOT use the general
// notification drawer/badge.
export const supportStore = proxy({
  // Unread admin replies across the support chat + tickets (badges the icon).
  unreadCount: 0,
  // Whether the support drawer is open.
  drawerOpen: false,
  // Bumped on any incoming support websocket event so open views refetch.
  liveTick: 0,
});

// refreshSupportUnread pulls the latest unread count from the backend.
export const refreshSupportUnread = () => {
  getSupportUnread(
    {
      onCompleted({ data }) {
        supportStore.unreadCount = data?.count ?? 0;
      },
      onError() {},
    },
    { bypassCache: true }
  );
};

export const openSupportDrawer = () => {
  supportStore.drawerOpen = true;
  // The user is opening support; clear the badge optimistically (the chat marks
  // the conversation read on load, which the next refresh confirms).
  supportStore.unreadCount = 0;
};

export const closeSupportDrawer = () => {
  supportStore.drawerOpen = false;
  refreshSupportUnread();
};
